import {MinusIcon, PlusIcon} from '@heroicons/react/24/outline';
import classNames from 'classnames';
import * as React from 'react';
import Collapsible from 'react-collapsible';

type FaqItem = {
  title: string;
  content: React.ReactNode;
};

export interface Props {
  title: string;
  data: FaqItem[];
}

const FaqSection = ({data, title}: Props) => {
  const [activeItem, setActiveItem] = React.useState<number | null>(null);

  return (
    <div className="mt-12">
      <h3 className="ml-1 font-semibold text-xl mt-16">{title}</h3>
      <div className="mt-6">
        {data.map((item, index) => (
          <div className="mt-2.5 bg-gray-100" key={index}>
            <Collapsible
              open={activeItem === index}
              transitionTime={150}
              onTriggerOpening={() => setActiveItem(index)}
              onTriggerClosing={() => setActiveItem(null)}
              trigger={
                <div
                  id={item.title.replace(/\s+/g, '-').toLowerCase()}
                  className={classNames(
                    'px-4 lg:px-6 py-6 font-semibold text-sm sm:text-base w-full flex justify-between items-center text-left',
                    activeItem === index ? 'text-orange1' : 'text-black1',
                  )}>
                  <div>{item.title}</div>
                  <div className="ml-2.5">
                    {activeItem === index ? (
                      <MinusIcon className="w-6 h-6" />
                    ) : (
                      <PlusIcon className="w-6 h-6" />
                    )}
                  </div>
                </div>
              }>
              <div className="px-4 lg:px-6 pb-6">{item.content}</div>
            </Collapsible>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqSection;
